import { types } from "../action-types";

const initialState = {
  loading: false,
  success: false,
  error: false,
  errorMessage: "",
  errorData: null,
  responseData: null,
  bidData: {},
};

const createBidReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.CREATE_BID_REQUESTED:
      return {
        ...state,
        loading: true,
        success: false,
        error: false,
        errorMessage: "",
        errorData: null,
        responseData: null,
      };

    case types.CREATE_BID_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        errorMessage: "",
        errorData: null,
        responseData: action.responseData || action.payload,
        bidData: action.payload,
      };
    case types.CREATE_BID_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: true,
        errorMessage: action.payload || "Something went wrong",
        errorData: action.errorData || null,
      };
      case types.CLEAR_BID_SUCCESS:
        return {
          loading: false,
          success: false,
          error: false,
          errorMessage: "",
          errorData: null,
          responseData: null,
          bidData: {},
          // initialState
        };

    case types.CREATE_MULTI_BID_REQUESTED:
      return {
        ...state,
        loading: true,
        success: false,
        error: false,
        errorMessage: "",
        errorData: null,
        responseData: null,
      };

    case types.CREATE_MULTI_BID_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        errorMessage: "",
        errorData: null,
        responseData: action.responseData || action.payload,
        bidData: action.payload
      };

    case types.CREATE_MULTI_BID_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: true,
        errorMessage: action.payload || "Something went wrong",
        errorData: action.errorData || null,
      };

    default:
      return state;
  }
};
export default createBidReducers;
